import { atom, selector } from "recoil"
import { NotificationNewUsersProps, NotificationNewMessagesProps } from "./type"

export const notificationNewUsersAtom = atom<NotificationNewUsersProps>({
  key: "notificationUsersAtom",
  default: {
    isSoundNewUser: false,
    isEnabledNotificationNewUsers: false
  }
})

export const notificationNewMessagesAtom = atom<NotificationNewMessagesProps>({
  key: "notificationNewMessagesAtom",
  default: {
    isSoundNewMessage: false,
    isEnabledNotificationNewMessages: false
  }
})

export const notificationNewUsersSelector = selector<NotificationNewUsersProps>(
  {
    key: "notificationNewUsersSelector",
    get: ({ get }) => get(notificationNewUsersAtom),
    set: ({ get, set }, newNotificationAtomParams) =>
      set(notificationNewUsersAtom, {
        ...get(notificationNewUsersAtom),
        ...newNotificationAtomParams
      })
  }
)

export const notificationNewMessagesSelector =
  selector<NotificationNewMessagesProps>({
    key: "notificationNewMessagesSelector",
    get: ({ get }) => get(notificationNewMessagesAtom),
    set: ({ get, set }, newNotificationAtomParams) =>
      set(notificationNewMessagesAtom, {
        ...get(notificationNewMessagesAtom),
        ...newNotificationAtomParams
      })
  })
